import { CSSObject, styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import { Theme } from '@mui/material';
import { designTokens } from '@design-system';

import { drawerWidth } from '../../AppConfig';

interface MiniDrawerStyledProps {
  open: boolean;
}

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  borderRight: 'none',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  boxShadow: designTokens.shadows.lg,
  background: `linear-gradient(180deg, ${designTokens.colors.background.dark} 0%, ${designTokens.colors.background.darkPaper} 50%, ${designTokens.colors.background.dark} 100%)`,
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: 0,
  borderRight: 'none',
  background: `linear-gradient(180deg, ${designTokens.colors.background.dark} 0%, ${designTokens.colors.background.darkPaper} 50%, ${designTokens.colors.background.dark} 100%)`,
  boxShadow: 'none',
});

const MiniDrawerStyled = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})<MiniDrawerStyledProps>(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

export default MiniDrawerStyled;
